import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Country } from 'country-state-city';
import { Admin } from '../../../services/admin';
import { Auth } from '../../../services/auth';
import { Verification } from '../../../services/verification';
import { SuccessDialog } from '../../common-features/success-dialog/success-dialog';
import { NavStateService } from '../../../services/nav-state.service';
import { User } from '../../../services/user';
import { ViewUploadedFile } from '../../common-features/view-uploaded-file/view-uploaded-file';

@Component({
  selector: 'app-canon-form',
  standalone: false,
  templateUrl: './canon-form.html',
  styleUrl: './canon-form.less',
})
export class CanonForm {
  canonForm!: FormGroup;
  private authService = inject(Auth);
  private verificationService = inject(Verification);
  private adminService = inject(Admin);
  private matDialog = inject(MatDialog);
  private router = inject(Router);
  private navState = inject(NavStateService);
  private userService = inject(User);
  user: any;
  record: any;
  mode: any;
  uploadedFile: File | null = null;
  isDragOver = false;
  countries = Country.getAllCountries();
  uploadedFiles: any[] = [];
  @Output() moveToCanonList = new EventEmitter<any>();
  constructor(private fb: FormBuilder) {
    const inputData = window.history.state;
    if (inputData) {
      this.record = inputData.record
      this.mode = inputData.mode
      console.log(this.record)
    }
    this.authService.user.subscribe((x: any) => this.user = x)
  }

  ngOnInit(): void {
    this.navState.setCurrentTitle(this.mode == 'edit' ? 'Edit Canon Form' : 'Create Canon Form');
    this.navState.setShowBackButton(true);
    this.canonForm = this.fb.group({
      easyNumber: ['', Validators.required],
      companyName: ['', Validators.required],
      country: ['', Validators.required],
      type: ['', Validators.required],
      registeredAddress: ['', Validators.required],
      companyCreditRecommendation: ['', Validators.required],
      companyRiskRating: ['', Validators.required],
    });
    this.canonForm.patchValue(this.record)
    if (this.mode == 'edit') {
      this.getUploadedDocuments(this.record.id)
    }
  }

  isFieldRequired(controlName: string): boolean {
    const control = this.canonForm.get(controlName);
    return control ? control.hasValidator(Validators.required) : false;
  }

  onFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    if (element.files && element.files.length > 0) {
      this.processFile(element.files[0]);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.processFile(event.dataTransfer.files[0]);
    }
  }

  private processFile(file: File): void {
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB

    if (!allowedTypes.includes(file.type)) {
      alert('Invalid file format. Please upload a PDF, JPG, or PNG file.');
      return;
    }

    if (file.size > maxSizeInBytes) {
      alert('File is too large. Maximum size allowed is 10MB.');
      return;
    }
    this.uploadedFile = file;
  }

  uploadFile(verificationId: any) {
    if (this.uploadedFile) {

      const mediaData = new FormData();
      mediaData.append("file", this.uploadedFile!);
      mediaData.append("entityType", 'COFANET-RECEIPT');
      mediaData.append("entityId", verificationId);
      mediaData.append("docType", 'verificationRequest');
      this.adminService
        .uploadProfilePic(mediaData)
        .pipe()
        .subscribe({
          next: (data: any) => {
            console.log(data);
            //success and error messages
            this.showSuccessAndErrorDialog('SUCCESS', 'Request created successfully!', 'success');

          },
          error: (error) => {
            this.showSuccessAndErrorDialog('ERROR', 'Could not create request. Please contact admin.', 'error');
            console.log(error);
          },
        });

      this.uploadedFile = null;
    }
  }

  onCancel(): void {
    this.canonForm.reset();
    this.uploadedFile = null;
  }

  onSubmit(): void {
    if (this.canonForm.valid) {
      console.log('Form Submitted successfully:', this.canonForm.value);
      const form = {
        ...this.canonForm.value,
        inactive: false,
      }
      console.log('form', form)
      if (this.mode == 'edit') {
        this.verificationService.patchCanonForm(this.record.id, form)
          .subscribe({
            next: (data: any) => {
              console.log(data)
              if (this.uploadedFile) {
                this.uploadFile(data.id)
              } else {
                this.showSuccessAndErrorDialog('SUCCESS', 'Request updated successfully!', 'success');
              }

            }, error: (error: any) => {
              console.log(error)
              this.showSuccessAndErrorDialog('ERROR', 'Could not update the  request. Please contact admin.', 'error');
            }
          })
      } else {
        this.verificationService.postCanonForm(this.record.id, form)
          .subscribe({
            next: (data: any) => {
              console.log(data)
              if (this.uploadedFile) {
                this.uploadFile(data.id)
              } else {
                this.showSuccessAndErrorDialog('SUCCESS', 'Request created successfully!', 'success',data);
              }

            }, error: (error: any) => {
              console.log(error)
              this.showSuccessAndErrorDialog('ERROR', 'Could not create request. Please contact admin.', 'error');
            }
          })
      }

    } else {
      this.canonForm.markAllAsTouched();
      const firstInvalidInput = Object.keys(this.canonForm.controls).find(key => this.canonForm.controls[key].invalid);
      console.log('First invalid field:', firstInvalidInput);
      if (firstInvalidInput) {
        let element = document.getElementById(firstInvalidInput);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      return;
    }
  }

  showSuccessAndErrorDialog(title: any, message: any, icon: any,responseData?:any) {
    const dialog = this.matDialog.open(SuccessDialog, {
      disableClose: true,
      width: '500px',
      data: {
        title: title,
        subtitle: message,
        icon: icon
      },
    })
    dialog.afterClosed().subscribe(result => {
      this.moveBack(responseData);
    })
  }
  moveBack(responseData?:any) {
    this.moveToCanonList.emit(responseData)
  }

  getUploadedDocuments(id: string) {
    this.userService.getMediaFiles("COFANET-RECEIPT", id).subscribe({
      next: (data: any) => {
        this.uploadedFiles = data;
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

  viewMediaFile(row: any) {
    console.log(row);
    let viewFileComponent = this.matDialog.open(ViewUploadedFile, {
      disableClose: true,
      height: '800px',
      width: '800px',
      data: row
    });
    viewFileComponent.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  deleteMedia(id: any) {
    this.userService.deleteMediaById(id).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }
}
